<div class="form-group">
    <label class="input-label">Minimum rows required in Grid</label>
    <input class="form-control"
           name="minRows"
           type="number"
           value="{{fieldOptions.validate.minRows}}"
           [(ngModel)]="fieldOptions.validate.minRows">
</div>